import { Button, Flex, List } from 'antd';

import getSentimentBadge from '@/lib/helpers/getSentimentBadgeColor';
import getTimeInSeconds from '@/lib/helpers/getTimeInSeconds';
import prepareTimestampStrFromNumber from '@/lib/helpers/prepareTimestampStrFromNumber';

import styles from './styles.module.css';

type TProps = {
	item: {
		[key: string]: {
			count: number;
			mentions: {
				time: number;
				score: number[];
				type: string;
			}[];
		};
	};
	videoSeekToTime: (seconds: number) => void;
	videoDuration: number;
};

export default function PromptsBrandEntityCollapsableItem({
	item,
	videoSeekToTime,
	videoDuration,
}: TProps) {
	// const badge = getSentimentBadge(item?.Sentiment);

	const itemName = Object.keys(item)?.[0];
	const mentions = Object.values(item)?.[0]?.mentions || [];

	return (
		<List.Item key={itemName} className="brand-entity-item">
			<List.Item.Meta
				// avatar={badge ? <span className={styles.badge}>{badge}</span> : null}
				title={
					<Flex
						gap={8}
						align="center"
						justify="flex-start"
						className={styles.flexWrap}
					>
						<span className={styles.itemName}>{itemName}</span>
						{/* <span className={styles.itemSummary}>{item?.Summary}</span> */}
					</Flex>
				}
				description={
					<Flex
						gap={8}
						align="center"
						justify="flex-start"
						className={styles.flexWrap}
						style={{ marginTop: '0.5rem', color: '#000' }}
					>
						{mentions?.map((mentionItem: any, idx: number) => {
							// if (typeof mentionItem === "string") {
							const seconds = (mentionItem as any)?.time;
							const preparedTimestampStr = prepareTimestampStrFromNumber(
								videoDuration,
								mentionItem?.time,
							);

							if (seconds !== null) {
								return (
									<Button
										key={'brand-timestamp-' + mentionItem?.time + idx}
										type="link"
										className={styles.timestampButton}
										onClick={() => videoSeekToTime(seconds)}
									>
										{preparedTimestampStr}
									</Button>
								);
							}

							return null;
						})}
					</Flex>
				}
			/>
		</List.Item>
	);
}
